import React, { useEffect } from 'react';
import CircularProgress from '../../components/common/CircularProgress';
import { message } from 'antd';

import Auxiliary from '../../util/Auxiliary';
import { useDispatch, useSelector } from 'react-redux';
import { hideMessage } from '../../redux/actions/Common';

message.config({
  duration: 2,
  maxCount: 1,
});

const InfoView = () => {
  const dispatch = useDispatch();
  const error = useSelector(({ common }) => common.error);
  const loading = useSelector(({ common }) => common.loading);
  const infoMessage = useSelector(({ common }) => common.message);

  useEffect(() => {
    if ((infoMessage && !error) || (!infoMessage && error)) {
      setTimeout(() => {
        dispatch(hideMessage());
      }, 300);
    }
  }, [dispatch]);

  return (
    <Auxiliary>
      {loading && (
        <div className="gx-loader-view gx-loader-position">
          <CircularProgress />
        </div>
      )}
      {error && message.error(<span id="message-id">{error}</span>)}
      {infoMessage && message.info(<span id="message-id">{infoMessage}</span>)}
    </Auxiliary>
  );
};

export default InfoView;
